/* Mission Beard — Beard Balm PDP interactivity.
   Ports the React design (pdp.jsx) to vanilla JS, then layers the cart-add
   + on-page Apple Pay pattern from beard-oil-pdp.js on top.
   - Scent toggle (Step 01) navigates between scent products (each has its own
     URL; the active card is inert).
   - Pack picker (Step 02) sets local qty 1–4.
   - Slot picker (Step 03) appears for qty>=2; each slot defaults to current
     scent; users can change to any scent.
   - ATC: qty=1 lets the embedded {% form 'product' %} submit normally (so
     express buttons work for the variant). qty>=2 hijacks click → POSTs
     multi-line items to /cart/add.js and applies the tier discount.
   - Mobile sticky ATC bar mirrors the main ATC. */
(function () {
  function init(root) {
    if (!root || root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    /* Meet-the-balm + FAQ accordions work without config. */
    root.querySelectorAll('[data-bb-meet-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-bb-meet-acc');
        var body = root.querySelector('[data-bb-meet-body="' + key + '"]');
        if (!body) return;
        var willOpen = !btn.classList.contains('open');
        btn.classList.toggle('open', willOpen);
        body.style.display = willOpen ? '' : 'none';
      });
    });
    root.querySelectorAll('[data-bb-faq-row]').forEach(function (row) {
      var btn = row.querySelector('.faq-q');
      var ans = row.querySelector('.faq-a');
      var ic  = row.querySelector('.faq-q svg');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var willOpen = !row.classList.contains('open');
        row.classList.toggle('open', willOpen);
        ans.style.display = willOpen ? '' : 'none';
        if (ic) {
          ic.innerHTML = willOpen
            ? '<line x1="5" y1="12" x2="19" y2="12"/>'
            : '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>';
        }
      });
    });
    var rvMore = root.querySelector('[data-bb-rv-more]');
    var rvJm = root.querySelector('[data-bb-rv-judgeme]');
    if (rvMore && rvJm) {
      rvMore.addEventListener('click', function () {
        rvJm.style.display = rvJm.style.display === 'none' ? '' : 'none';
        rvMore.textContent = rvJm.style.display === 'none' ? 'Load more reviews' : 'Hide full review list';
      });
    }

    var configEl = root.querySelector('[data-bb-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : null;
    if (!config) return;

    var scents = config.scents || {};
    var packs = config.packs || [];
    var currency = config.currencySymbol || '£';
    var freeShipThreshold = config.freeShipThreshold || 30;

    var state = {
      qty: config.defaultQty || 1,
      primary: config.current.scentId,
      slots: [config.current.scentId, null, null, null]
    };

    function money(n) { return currency + Number(n).toFixed(2); }
    function packOf(q) { return packs.find(function (p) { return p.q === q; }) || packs[0]; }
    function scentOf(id) { return scents[id]; }
    function primaryScent() { return scentOf(state.primary) || Object.values(scents)[0]; }
    function unitPriceOf(id) {
      var s = scentOf(id);
      return (s && s.unitPrice != null) ? Number(s.unitPrice) : config.current.unitPrice;
    }

    /* ────── GALLERY ────── */
    var heroImg = root.querySelector('[data-bb-hero-img]');
    var thumbs  = root.querySelectorAll('[data-bb-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.classList.remove('active'); });
        t.classList.add('active');
        if (heroImg) {
          heroImg.src = t.getAttribute('data-src');
          var fit = t.getAttribute('data-fit') || 'contain';
          heroImg.className = 'hero-img ' + fit;
        }
      });
    });

    /* ────── PACK PICKER (Step 02) ────── */
    var packEls = root.querySelectorAll('[data-bb-pack]');
    packEls.forEach(function (el) {
      el.addEventListener('click', function () {
        state.qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        // Grow/shrink slot defaults
        for (var i = 0; i < state.qty; i++) {
          if (!state.slots[i]) state.slots[i] = state.primary;
        }
        // Close any open slot picker
        root.querySelectorAll('.slot.open').forEach(function (s) { s.classList.remove('open'); });
        renderAll();
      });
    });

    /* ────── SLOT PICKER (Step 03) ────── */
    var slotRows = root.querySelectorAll('[data-bb-slot]');
    slotRows.forEach(function (slot) {
      var idx = parseInt(slot.getAttribute('data-bb-slot'), 10);
      var row = slot.querySelector('[data-bb-slot-row]');
      var swatches = slot.querySelectorAll('[data-bb-swatch]');
      if (row) {
        row.addEventListener('click', function () {
          var open = slot.classList.contains('open');
          // Close others
          root.querySelectorAll('.slot.open').forEach(function (s) {
            if (s !== slot) s.classList.remove('open');
          });
          slot.classList.toggle('open', !open);
        });
      }
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.stopPropagation();
          if (sw.getAttribute('data-sold-out') === 'true') return;
          state.slots[idx] = sw.getAttribute('data-scent-id');
          slot.classList.remove('open');
          renderAll();
        });
      });
    });

    /* ────── RENDER ────── */
    var packPerEls = root.querySelectorAll('[data-bb-pack-per]');
    var subLabel   = root.querySelector('[data-bb-sub-label]');
    var subNow     = root.querySelector('[data-bb-sub-now]');
    var subWas     = root.querySelector('[data-bb-sub-was]');
    var saveRow    = root.querySelector('[data-bb-save-row]');
    var saveAmt    = root.querySelector('[data-bb-save-amt]');
    var savePct    = root.querySelector('[data-bb-save-pct]');
    var freeship   = root.querySelector('[data-bb-freeship]');
    var atcBtn     = root.querySelector('[data-bb-atc]');
    var atcLabel   = root.querySelector('[data-bb-atc-label]');
    var atcPrice   = root.querySelector('[data-bb-atc-price]');
    var step3      = root.querySelector('[data-bb-step3]');
    var slotCount  = root.querySelector('[data-bb-slot-count]');
    var compWrap   = root.querySelector('[data-bb-composition]');
    var compChips  = root.querySelector('[data-bb-comp-chips]');
    var mobileBar  = document.querySelector('[data-bb-mobile-atc]');
    var mPhoto     = document.querySelector('[data-bb-m-photo]');
    var mName      = document.querySelector('[data-bb-m-name]');
    var mNow       = document.querySelector('[data-bb-m-now]');
    var mWas       = document.querySelector('[data-bb-m-was]');
    var mBtn       = document.querySelector('[data-bb-m-atc]');

    function computeTotals() {
      var pack = packOf(state.qty);
      var wasTotal = 0;
      var slotIds = state.slots.slice(0, state.qty);
      slotIds.forEach(function (id) {
        wasTotal += unitPriceOf(id || state.primary);
      });
      // Prefer hardcoded tier totals (matches the actual BEARD code checkout); fall
      // back to unit × qty × (1 - off) if no override is set on this pack.
      var total = (pack.total != null) ? Number(pack.total) : (wasTotal * (1 - pack.off));
      var saving = wasTotal - total;
      var filled = slotIds.filter(Boolean).length;
      var allFilled = filled === state.qty;
      return { pack: pack, wasTotal: wasTotal, total: total, saving: saving, filled: filled, allFilled: allFilled };
    }

    function renderPacks() {
      packEls.forEach(function (el) {
        var q = parseInt(el.getAttribute('data-qty'), 10);
        el.classList.toggle('active', q === state.qty);
      });
      // Per-tin price display = tier total / qty when overridden, else unit × (1 - off).
      var primaryUnit = unitPriceOf(state.primary);
      packEls.forEach(function (el) {
        var q = parseInt(el.getAttribute('data-qty'), 10);
        var pack = packOf(q);
        var per;
        if (pack && pack.total != null) {
          per = Number(pack.total) / q;
        } else {
          var off = parseInt(el.getAttribute('data-off'), 10) / 100;
          per = primaryUnit * (1 - off);
        }
        var perEl = el.querySelector('[data-bb-pack-per]');
        if (perEl) perEl.textContent = money(per);
      });
    }

    function renderSlots() {
      var showStep3 = state.qty >= 2;
      if (step3) step3.style.display = showStep3 ? '' : 'none';
      slotRows.forEach(function (slot) {
        var idx = parseInt(slot.getAttribute('data-bb-slot'), 10);
        slot.style.display = idx < state.qty ? '' : 'none';
        var sId = state.slots[idx];
        var s = sId ? scentOf(sId) : null;
        var photo = slot.querySelector('[data-bb-slot-photo]');
        var name  = slot.querySelector('[data-bb-slot-name]');
        var cta   = slot.querySelector('[data-bb-slot-cta]');
        slot.classList.toggle('empty', !s);
        if (photo) {
          photo.style.background = s ? s.bg : '#E6E6E6';
          photo.innerHTML = s ? '<img src="' + s.lifestyle + '" alt="">' : '';
        }
        if (name) {
          if (s) name.innerHTML = '<span class="dot-c" style="background:' + s.color + ';"></span> ' + s.name;
          else name.innerHTML = '<span class="muted">Choose a scent</span>';
        }
        if (cta) {
          cta.innerHTML = (s ? 'Change' : 'Pick') + ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        }
        // Update swatch active state
        var sws = slot.querySelectorAll('[data-bb-swatch]');
        sws.forEach(function (sw) {
          sw.classList.toggle('active', sw.getAttribute('data-scent-id') === sId);
        });
      });
      if (slotCount) {
        var filled = state.slots.slice(0, state.qty).filter(Boolean).length;
        slotCount.textContent = filled + ' of ' + state.qty;
      }
    }

    function renderComposition() {
      var t = computeTotals();
      var shouldShow = state.qty >= 2 && t.allFilled;
      if (compWrap) compWrap.style.display = shouldShow ? '' : 'none';
      if (compChips) {
        var counts = {};
        state.slots.slice(0, state.qty).forEach(function (id) {
          if (id) counts[id] = (counts[id] || 0) + 1;
        });
        compChips.innerHTML = Object.keys(counts).map(function (id) {
          var s = scentOf(id);
          return '<span class="comp-chip"><span class="dot-c" style="background:' + s.color + ';"></span> ' + counts[id] + '× ' + s.name + '</span>';
        }).join(' ');
      }
    }

    function renderPricing() {
      var t = computeTotals();
      if (subLabel) subLabel.textContent = state.qty + ' ' + (state.qty === 1 ? 'tin' : 'tins');
      if (subNow) subNow.textContent = money(t.total);
      if (subWas) {
        if (state.qty >= 2) { subWas.style.display = ''; subWas.textContent = money(t.wasTotal); }
        else subWas.style.display = 'none';
      }
      if (saveRow) saveRow.style.display = state.qty >= 2 ? '' : 'none';
      if (saveAmt) saveAmt.textContent = money(t.saving);
      if (savePct) savePct.textContent = Math.round(t.pack.off * 100);
      if (freeship) freeship.textContent = t.total >= freeShipThreshold ? '✓ Free UK shipping' : (money(freeShipThreshold - t.total) + ' to free shipping');

      // ATC button label
      if (atcBtn) {
        atcBtn.classList.remove('disabled', 'done');
        var disabled = state.qty >= 2 && !t.allFilled;
        if (disabled) {
          atcBtn.classList.add('disabled');
          if (atcLabel) atcLabel.textContent = 'Pick ' + (state.qty - t.filled) + ' more ' + (state.qty - t.filled === 1 ? 'scent' : 'scents');
          if (atcPrice) atcPrice.textContent = '';
        } else {
          if (atcLabel) atcLabel.textContent = 'Add to cart · ' + state.qty + ' ' + (state.qty === 1 ? 'tin' : 'tins');
          if (atcPrice) atcPrice.textContent = money(t.total);
        }
      }

      // Mobile sticky bar
      if (mobileBar) {
        var ps = primaryScent();
        if (mPhoto && ps) mPhoto.src = ps.hero;
        if (mName) mName.textContent = ps.name + ' Balm' + (state.qty > 1 ? ' · ' + state.qty + '-pk' : '');
        if (mNow) mNow.textContent = money(t.total);
        if (mWas) {
          if (state.qty >= 2) { mWas.style.display = ''; mWas.textContent = money(t.wasTotal); }
          else mWas.style.display = 'none';
        }
        if (mBtn) {
          var dis = state.qty >= 2 && !t.allFilled;
          mBtn.classList.toggle('disabled', dis);
          mBtn.textContent = dis ? ('Pick ' + (state.qty - t.filled) + ' more') : 'Add to cart';
        }
      }
    }

    function renderAll() {
      renderPacks();
      renderSlots();
      renderComposition();
      renderPricing();
      root.classList.toggle('qty-multi', state.qty > 1);
    }

    /* ────── ATC ────── */
    function buildLineItems() {
      var counts = {};
      state.slots.slice(0, state.qty).forEach(function (id) {
        if (!id) return;
        counts[id] = (counts[id] || 0) + 1;
      });
      var items = [];
      for (var id in counts) {
        var s = scentOf(id);
        if (!s || !s.variantId) {
          throw new Error('The ' + (s ? s.name : id) + ' balm scent isn\'t live yet — pick a different scent in your mix.');
        }
        items.push({ id: Number(s.variantId), quantity: counts[id] });
      }
      return items;
    }
    function notifyCart() {
      ['cart:refresh','cart:updated','cart:add','cart:change','shopify:cart:add'].forEach(function (n) {
        document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'bb-pdp' } }));
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'bb-pdp' } }));
      });
    }
    function reportError(msg) {
      console.error('[bb-pdp] ' + msg);
      try { alert(msg); } catch (_) {}
    }
    function handleAtc() {
      var t = computeTotals();
      if (state.qty >= 2 && !t.allFilled) return;

      // qty=1: let the real product form submit so express buttons work.
      // For the regular button click, we'd want the cart drawer to open — POST to /cart/add.js
      // for qty=1 too so behavior is identical (no full-page checkout redirect).
      var items;
      try { items = buildLineItems(); }
      catch (err) { reportError(err.message); return; }

      var btnsToDisable = [atcBtn, mBtn].filter(Boolean);
      btnsToDisable.forEach(function (b) { b.disabled = true; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (txt) {
          var p; try { p = JSON.parse(txt); } catch (_) {}
          throw new Error((p && p.description) || ('Could not add to cart (' + r.status + ')'));
        });
        return r.json();
      }).then(function () {
        notifyCart();
        if (atcBtn) {
          atcBtn.classList.add('done');
          if (atcLabel) atcLabel.textContent = '✓ Added to cart';
          if (atcPrice) atcPrice.textContent = '';
          setTimeout(function () { atcBtn.classList.remove('done'); renderPricing(); }, 1400);
        }
      }).catch(function (err) {
        reportError(err.message || 'Could not add to cart');
      }).finally(function () {
        btnsToDisable.forEach(function (b) { b.disabled = false; });
      });
    }
    if (atcBtn) atcBtn.addEventListener('click', handleAtc);
    if (mBtn) mBtn.addEventListener('click', handleAtc);

    /* ────── Mobile sticky bar IntersectionObserver ────── */
    if (mobileBar && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          mobileBar.classList.toggle('visible', !e.isIntersecting);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      io.observe(atcBtn);
    }

    /* ────── Initial paint ────── */
    renderAll();
  }

  function boot() {
    var roots = document.querySelectorAll('.bb-pdp[data-bb-pdp]');
    roots.forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
